import React from 'react';

export interface TaskListHeaderProps {
  headerHeight: number;
  rowWidth: string;
  fontFamily: string;
  fontSize: string;
}

export const TaskListHeader = ({ headerHeight, rowWidth }: TaskListHeaderProps) => {
  return (
    <div
      style={{
        height: headerHeight - 2,
        minWidth: `calc(${rowWidth} * 2)`,
      }}
    ></div>
  );
};
